import { PartyOverviewItemDto } from '../config/partyConfig'
import { isAppContext } from './appHelper'
import { AppContext } from '../config/appConfig'
import { outlookDisplayNewAppointmentForm, outlookDisplayNewMessageForm } from './outlookHelper'

/**
 * Opens a new Outlook message addressed to the party. When running inside the compose surface the recipients are
 * appended to the current draft, otherwise a fresh message form is opened (with a mailto: fallback when Office is
 * not initialized).
 *
 * Extracted from the legacy FilePartyList so the v9 party overview can reuse it without importing the old list.
 */
export const composeEmailClick = (party: PartyOverviewItemDto, subject?: string): (() => void) => {
    return () => {
        if (isAppContext([AppContext.Compose])) {
            Office.context.mailbox.item?.to?.addAsync?.(
                party.email.split(/[,;]/).map(emailAddress => ({
                    displayName: party.displayName,
                    emailAddress,
                })),
            )
        } else {
            outlookDisplayNewMessageForm({
                toRecipients: (party.email?.split(/[,;]/).map(email => ({
                    displayName: party.displayName,
                    emailAddress: email?.trim(),
                })) || []) as Office.EmailAddressDetails[],
                subject: subject,
            })
        }
    }
}

/**
 * Opens a new Outlook appointment form with the party as required attendee.
 */
export const composeAppointmentClick = (party: PartyOverviewItemDto, subject?: string): (() => void) => {
    return () => {
        outlookDisplayNewAppointmentForm({
            requiredAttendees: party.email.split(/[,;]/).map(email => ({
                displayName: party.displayName,
                emailAddress: email?.trim(),
            })) as Office.EmailAddressDetails[],
            subject: subject,
        })
    }
}
